const initializeWebinarButtons = (allButtons) => {
  [...allButtons].forEach( button => {
    const allForms = document.querySelectorAll( '.gf-form' );
    const anchor = 'anchor-form';

    // Hide the button if there are no forms on the page, would be useless otherwise.
    if (allForms.length === 0) {
      button.style.display = 'none';
    }

    // Add an ID to the first form on the page, so we can target it later.
    allForms[0].id = anchor;

    // Change the href of the button, so we can scroll to the form.
    button.href = '#' + anchor;
  } );
};

const webinarButtons = (allButtons) => {
  if (!allButtons) {
    return;
  }

  initializeWebinarButtons( allButtons );
};

export default webinarButtons;